import { type FC } from 'react';

import Heading, { type HeadingProps } from 'components/_core/Heading';

const Title: FC<HeadingProps> = (props) => (
  <Heading marginBottom="space-16" {...props} />
);

export default Title;
